export default "__VITE_ASSET__CcS67kty__"